import common from './common.scss';
import darkMode from './dark-mode.scss';
import lightMode from './light-mode.scss';

export default { ...darkMode, ...lightMode, ...common };
